import React, { useEffect, useState,useCallback } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Sidebar from '../Sidebar';
import Header from '../Header';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import Card from 'react-bootstrap/Card';
import { useDispatch, useSelector } from 'react-redux';
import Table from 'react-bootstrap/Table';
import {NavLink} from 'react-router-dom';
import Pagination from 'react-bootstrap/Pagination';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // import the styles
import { deleteJob, fetchJobs, updateJob,addJob,updateStatus, filterJobs } from '../../redux/actions/jobsActions';
import debounce from "lodash/debounce";

function ActiveJobs() {
    const sidebarState = useSelector(state => state.sidebarReducres);
    const jobs = useSelector(state=> state.jobsReducer.jobs)
    const dispatch = useDispatch()
    const [show, setShow] = useState(false);
    const [job,setJob] = useState({id:"",location:"",position:"",experience:"",type:"",tags:"",status:false})
    const [value, setValue] = useState('');
    const handleClose = () => setShow(false);
    const [activeTab,setActiveTab] = useState(true);
    const [loading,setLoading] = useState(true);
    const [currentPage,setCurrentPage] = useState(1);
    const [displayPages,setDisplayPages] = useState([])
    const [totalPages,setTotalPages] = useState(0)
    const [searchText,setSearchText] = useState('')
    const [error,setError] = useState({description:"",location:"",position:"",experience:"",type:"",tags:""})

    useEffect(()=>{
        onFetchJobs({page:1})
    },[])
    
    const onFetchJobs = async(params) =>{
        setLoading(true)
        if(params && params.offsetZero){
            setCurrentPage(1)
		}
        const queryParams = {
			start: params.offsetZero ? 0 : (10*(params.page-1)),
			end: (params.page*10)-1,
		};
        const res = await dispatch(fetchJobs(queryParams))
        if(res.success){
            const totalCount = res?.data?.length > 0 ? res?.count : 1;
            setTotalPages(Math.ceil(totalCount / 10))
            generateDisplayPages(Math.ceil(totalCount / 10),params.page)
            setLoading(false)
        }else if(!res.success){
            setLoading(false)
        }
    }

    const onDelete = async(item) =>{
        setLoading(true)
        const res = await dispatch(deleteJob(item.id))
        if(res.success){
            setCurrentPage(1)
            if(searchText.trim().length>=3){
                await handleSearch(searchText)
            }else{
                await onFetchJobs({page:1,offsetZero:true})
            }
            setLoading(false)
        }
    }

    const onUpdate = (item)=>{
        setShow(true)
        setError({location:"",position:"",experience:"",type:"",tags:"",description:""})
        const {id,location,position,description,experience,status,tags,type} = item
        setJob({id,location,position,experience,type,tags,status})
        setValue(description)
    }

    const handleUpdate = async() =>{
        const jobdata = job
        const {location,position,experience,type,tags} = job
        let validate = true;
        if(location==''){
            setError((prev) => ({
                ...prev,
                location: "Location must be required",
            }));
            validate = false
        }
        if(position==''){
            setError((prev) => ({
                ...prev,
                position: "Position must be required",
            }));
            validate = false
        }
        if(experience==''){
            setError((prev) => ({
                ...prev,
                experience: "Experience must be required",
            }));
            validate = false
        }
        if(type=='' || type=="Select Type"){
            setError((prev) => ({
                ...prev,
                type: "Type must be required",
            }));
            validate = false
        }
        if(tags==''){
            setError((prev) => ({
                ...prev,
                tags: "Tags must be required",
            }));
            validate = false
        }
        if(value==''){
            setError((prev) => ({
                ...prev,
                description: "Description must be required",
            }));
            validate = false
        }
        if(validate){
            jobdata.description = value
            setLoading(true)
            const res = await dispatch(updateJob(jobdata))
            if(res.success){
                setJob({id:"",location:"",position:"",experience:"",type:"",tags:"",status:false})
                setValue('')
                setCurrentPage(1)
                if(searchText.trim().length>=3){
                    await handleSearch(searchText)
                }else{
                    await onFetchJobs({page:1,offsetZero:true})
                }
                setShow(false)
            }
            setLoading(false)
        }
    }

    const onChange = (e) =>{
        const { name, value } = e.target;
        if(name=="status"){
            setJob((prev) => ({
            ...prev,
            [name]: !job.status,
            }))
        }else{
            setJob((prev) => ({
                ...prev,
                [name]: value,
            }));
            setError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }
    }

    const newJob = async() =>{
        const jobdata = job
        const {location,position,experience,type,tags} = job
        let validate = true;
        if(location==''){
            setError((prev) => ({
                ...prev,
                location: "Location must be required",
            }));
            validate = false
        }
        if(position==''){
            setError((prev) => ({
                ...prev,
                position: "Position must be required",
            }));
            validate = false
        }
        if(experience==''){
            setError((prev) => ({
                ...prev,
                experience: "Experience must be required",
            }));
            validate = false
        }
        if(type=='' || type=="Select Type"){
            setError((prev) => ({
                ...prev,
                type: "Type must be required",
            }));
            validate = false
        }
        if(tags==''){
            setError((prev) => ({
                ...prev,
                tags: "Tags must be required",
            }));
            validate = false
        }
        if(value==''){
            setError((prev) => ({
                ...prev,
                description: "Description must be required",
            }));
            validate = false
        }
        if(validate){
            jobdata.status = true
            jobdata.description = value
            setLoading(true)
            const res = await dispatch(addJob(jobdata))
            if(res.success){
                setJob({location:"",position:"",experience:"",type:"",tags:""})
                setValue('')
                setActiveTab(true)
                setCurrentPage(1)
                if(searchText.trim().length>=3){
                    await handleSearch(searchText)
                }else{
                    await onFetchJobs({page:1,offsetZero:true})
                }
            }
            setLoading(false)
        }
    }

    const ontab = (flag) =>{
        setError({location:"",position:"",experience:"",type:"",tags:"",description:""})
        setJob({location:"",position:"",experience:"",type:"",tags:""})
        setValue('')
        setActiveTab(flag)
    }

    const onChangeStatus = async(e)=>{
        setLoading(true)
        const jobdata = {id:e.target.id,status:e.target.value=="on"?false:true}
        const res = await dispatch(updateStatus(jobdata))
        if(res.success){
            setCurrentPage(1)
            if(searchText.trim().length>=3){
                await handleSearch(searchText)
            }else{
                await onFetchJobs({page:1})
            }
            setLoading(false)
        }
    }

    const handleSearch = async(query,page)=>{
        setSearchText(query)
        if(query.trim().length >= 3){
        setLoading(true)
        let res;
        if(!page){
            setCurrentPage(1)
        }
        const start = page ? (10*(page-1)): 0
		const end = page ? ((page*10)-1):9
        if(query.trim().length){
            res = await dispatch(filterJobs({position:query.trim(),start:start,end:end}))
        }else{
            await onFetchJobs({page:1,offsetZero:true})
            setLoading(false)
        }
        if(res && res.success){
            const totalCount = res?.data?.length > 0 ? res?.count : 1;
            setTotalPages(Math.ceil(totalCount / 10))
            generateDisplayPages(Math.ceil(totalCount / 10),currentPage)
            setLoading(false)
        }else if(res && !res.success){
            setLoading(false)
        }
    }else if(query.trim().length === 0){
        let res;
        setLoading(true)
        await onFetchJobs({page:1,offsetZero:true})
        setLoading(false)
        if(res && res.success){
            setLoading(false)
        }else if(res && !res.success){
            setLoading(false)
        }
    }
    }

    const debouncedHandleSearch = useCallback(debounce(handleSearch, 100), []);

	const handlePaginationChange = async(params) => {
        if(params && params.offsetZero){
			setCurrentPage(1)
		}
        setCurrentPage(params.page)
        if(searchText.trim().length>3){
            await handleSearch(searchText,params.page)
        }else{
            await onFetchJobs(params)
        }
	};

    const renderPaginationItems = () => {
		return (
			<>
				<Pagination className="ml-auto">
					<Pagination.Prev disabled={currentPage == 1} onClick={() => handlePaginationChange({page:currentPage-1})} />
					{displayPages.map((page, index) => (
						<React.Fragment key={index}>
							{page === '...' ? (
								<Pagination.Ellipsis className='pagination-elipsis-disabled' />
							) : (
								<Pagination.Item
									className={page !== '...' ? 'pagination-number' : ''}
									active={page === currentPage}
									onClick={() => (page !== '...' && page!==currentPage && handlePaginationChange({page:page}))}
								>
									{page}
								</Pagination.Item>
							)}
						</React.Fragment>
					))}
					<Pagination.Next disabled={currentPage == totalPages}  onClick={() => handlePaginationChange({page:currentPage+1})} />
				</Pagination>
			</>
		);
	}

    const generateDisplayPages = (totalPages,currentPage) => {
		const displayPages = [];
		if (totalPages <= 5) {
			for (let i = 1; i <= totalPages; i++) {
				displayPages.push(i);
			}
		} else {
			if (currentPage <= 2) {
				for (let i = 1; i <= 3; i++) {	
					displayPages.push(i);
				}
				displayPages.push('...');
				displayPages.push(totalPages);
			} else if (currentPage >= totalPages - 1) {
				displayPages.push(1);
				displayPages.push('...');
				for (let i = totalPages - 2; i <= totalPages; i++) {
					displayPages.push(i);
				}
			} else {
				displayPages.push(1);
				if(currentPage>=4){
					displayPages.push('...')
				}
				for (let i = currentPage - 1; i <= currentPage + 1; i++) {
					displayPages.push(i);
				}
				if(currentPage<=totalPages-3){
					displayPages.push('...');
				}
				displayPages.push(totalPages);
			}
		}
		setDisplayPages(displayPages)
	}

    const onDescChange = (value) =>{
        setError((prev) => ({
            ...prev,
            description: '',
        }));
        setValue(value)
    }

    return (
        <>
        <Sidebar currenTab={activeTab} changeTab={(flag)=>ontab(flag)}/>
        <Header/>
        <div className={`main-content ${!sidebarState ? '' : 'navbar-ful'}`}>
            <div className='page-content'>
                <Container fluid>
                    <Row>
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className='p-0'>
                            <Card>
                                {activeTab&&
                                <>
                                <Card.Body>
                                    <div className='mb-3 d-flex align-items-center justify-content-between'>
                                        <div>
                                            <h5 className='d-inline-block mb-0'>Active Jobs</h5>
                                        </div>
                                        <div>
                                            <input type="search" value={searchText} name="search" onChange={(e) => debouncedHandleSearch(e.target.value)} className='form-control w-auto d-inline' placeholder='Search...'/>
                                            <NavLink onClick={()=>ontab(false)} className='mx-2 d-inline-block btn btn-primary'>Add Job+</NavLink>
                                        </div>
                                    </div>
                                    <hr className='m-0'/>
                                    {!loading?
                                    <>
                                    <Table striped hover size="xxl">
                                        <thead>
                                            <tr>
                                            <th>ID</th>
                                            <th>Position</th>
                                            <th>Date</th>
                                            <th>Type</th>
                                            <th>Location</th>
                                            <th>Experience</th>
                                            <th>Tags</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {jobs?.map((item,index)=>{
                                            return(<tr key={index}>
                                                <td>{item.id}</td>
                                                <td>{item.position}</td>
                                                <td>{new Date(item.created_at).getDate() + '-' +  (new Date(item.created_at).getMonth()+1) + '-' + new Date(item.created_at).getFullYear()}</td>
                                                <td>{item.type}</td>
                                                <td>{item.location}</td>
                                                <td>{item.experience}</td>
                                                <td>{item.tags}</td>
                                                <td>
                                                    <Form.Check
                                                        name='status' 
                                                        checked={item.status}
                                                        onChange={(e)=>onChangeStatus(e)}
                                                        type="switch"
                                                        id={item.id}
                                                        className='togg-size switch-table'
                                                        value={item.status?"on":"off"}
                                                    />
                                                </td>
                                                <td className='action'>
                                                    <i className='fa fa-edit' onClick={()=>onUpdate(item)}></i> &nbsp;<i className='fa fa-trash' onClick={()=>onDelete(item)}></i>
                                                </td>
                                            </tr>)
                                            })}
                                        </tbody>
                                    </Table>
                                    {renderPaginationItems()}
                                    </>
                                    :<div className='spinner'><Spinner animation="grow"/></div>}
                                </Card.Body>
                                </>}
                                {!activeTab &&
                                <Card.Body>
                                <Card.Title>Add New Jobs</Card.Title>
                                <Form className='mt-4'>
                                    <Row>
                                        <Col xs="12" sm="12" md="3" lg="3" xl="3" xxl="3">
                                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                <Form.Label>Job Location</Form.Label>
                                                <Form.Control name='location' value={job.location} onChange={(e)=>onChange(e)} type="text" placeholder="Job Location.." required/>
                                                {error.location && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.location}</small>}
                                            </Form.Group>
                                        </Col>
                                        <Col xs="12" sm="12" md="6" lg="6" xl="6" xxl="6">
                                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                <Form.Label>Job Position</Form.Label>
                                                <Form.Control name="position" value={job.position} onChange={(e)=>onChange(e)} type="text" placeholder="Job Position.." required/>
                                                {error.position && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.position}</small>}
                                            </Form.Group>
                                        </Col>
                                        <Col xs="12" sm="12" md="3" lg="3" xl="3" xxl="3">
                                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                <Form.Label>Required Experience</Form.Label>
                                                <Form.Control name="experience" value={job.experience} onChange={(e)=>onChange(e)} type="text" placeholder="Required Experience.." required/>
                                                {error.experience && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.experience}</small>}
                                            </Form.Group>
                                        </Col>
                                        <Col xs="12" sm="12" md="3" lg="3" xl="3" xxl="3">
                                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                <Form.Label>Job Type</Form.Label>
                                                <Form.Select name="type" value={job.type} onChange={(e)=>onChange(e)} aria-label="Default select example" required>
                                                    <option>Select Type</option>
                                                    <option value="Full-Time">Full-Time</option>
                                                    <option value="Part-Time">Part-Time</option>
                                                    <option value="Training">Training</option>
                                                    <option value="Freelancer">Freelancer</option>
                                                </Form.Select>
                                                {error.type && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.type}</small>}
                                            </Form.Group>
                                        </Col>
                                        <Col xs="12" sm="12" md="9" lg="9" xl="9" xxl="9">
                                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                <Form.Label>Job Tags</Form.Label>
                                                <Form.Control name="tags" value={job.tags} onChange={(e)=>onChange(e)} type="text" placeholder="Job Tags.." />
                                                {error.tags && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.tags}</small>}
                                            </Form.Group>
                                        </Col>
                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                <Form.Label>Job Description</Form.Label>
                                                <ReactQuill
                                                    value={value}
                                                    onChange={onDescChange}
                                                    theme="snow" 
                                                    className='code-editot'
                                                />
                                                {error.description && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.description}</small>}
                                            </Form.Group>
                                        </Col>
                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className='mt-4'>
                                            <input type='button' name="submit" onClick={newJob} className='btn btn-primary' value="Add Job"/>
                                        </Col>
                                    </Row>
                                </Form>
                                </Card.Body>}
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
        <Modal show={show} onHide={handleClose} className='modal-dialog-centered'>
            <Modal.Header closeButton>
            <Modal.Title>Edit Job</Modal.Title>
            </Modal.Header>
                <Modal.Body>
                    <Form className='mt-0'>
                        <Row>
                            <Col xs="12" sm="12" md="6" lg="6" xl="6" xxl="6">
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Job Location</Form.Label>
                                    <Form.Control name='location' value={job.location} onChange={(e)=>onChange(e)} type="text" placeholder="Job Location.." required/>
                                    {error.location && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.location}</small>}
                                    </Form.Group>
                            </Col>                        
                            <Col xs="12" sm="12" md="6" lg="6" xl="6" xxl="6">
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Job Position</Form.Label>
                                    <Form.Control name='position' value={job.position} onChange={(e)=>onChange(e)} type="text" placeholder="Job Position.." required/>
                                    {error.position && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.position}</small>}
                                </Form.Group>
                            </Col>
                            <Col xs="12" sm="12" md="6" lg="6" xl="6" xxl="6">
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Required Experience</Form.Label>
                                    <Form.Control name='experience' value={job.experience} onChange={(e)=>onChange(e)} type="text" placeholder="Required Experience.." required/>
                                    {error.experience && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.experience}</small>}
                                </Form.Group>
                            </Col>
                            <Col xs="12" sm="12" md="6" lg="6" xl="6" xxl="6">
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Job Type</Form.Label>
                                        <Form.Select name='type' value={job.type} onChange={(e)=>onChange(e)} aria-label="Default select example" required>
                                            <option>Select Type</option>
                                            <option value="Full-Time">Full-Time</option>
                                            <option value="Part-Time">Part-Time</option>
                                            <option value="Training">Training</option>
                                            <option value="Freelancer">Freelancer</option>
                                        </Form.Select>
                                        {error.type && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.type}</small>}
                                </Form.Group>
                            </Col>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Job Tags</Form.Label>
                                    <Form.Control name='tags' value={job.tags} onChange={(e)=>onChange(e)} type="text" placeholder="Job Tags.." />
                                    {error.tags && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.tags}</small>}
                                </Form.Group>
                            </Col>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                <Form.Group className="mb-1" controlId="exampleForm.ControlInput1">
                                 <Form.Label>Job Description</Form.Label>
                                <ReactQuill
                                    value={value}
                                    theme="snow" 
                                    className='code-editot'
                                    onChange={onDescChange}
                                    />
                                    {error.description && <small className="form-text mt-1 d-block" style={{color: '#F44336'}}>{error.description}</small>}
                                </Form.Group>
                            </Col>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className='mt-4'>
                            <Form.Group className="mb-1" controlId="exampleForm.ControlInput1">
                                <Form.Label>Active/Deactive</Form.Label>
                                    <Form.Check
                                    name='status' 
                                    checked={job.status}
                                    onChange={(e)=>onChange(e)}
                                    type="switch"
                                    id="custom-switch"
                                    className='togg-size'
                                    />
                            </Form.Group>
                            </Col>
                        </Row>                         
                    </Form>
                </Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Close
            </Button>
            <Button variant="primary" onClick={()=>handleUpdate()}>
                Save Changes
            </Button>
            </Modal.Footer>
        </Modal>
        </>
    );
}

export default ActiveJobs;
